var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personnel-decoration"},[(String(_vm.editpersonnel_temporary.id_card).length > 11)?_c('Personnel_decoration',{attrs:{"editpersonnel_temporary":_vm.editpersonnel_temporary}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }